export interface TransacaoFinanceira {
  id: string
  tipo: 'entrada' | 'saida'
  categoria: string
  descricao: string
  valor: number
  data: string
  responsavel: string
  comprovante?: string
  observacoes?: string
  status: 'pendente' | 'aprovado' | 'rejeitado'
}

export interface CategoriaFinanceira {
  id: string
  nome: string
  tipo: 'entrada' | 'saida'
  cor: string
  icone: string
}

export interface ResumoFinanceiro {
  totalEntradas: number
  totalSaidas: number
  saldo: number
  transacoesPendentes: number
}

export interface SaldoSeparado {
  igreja: {
    saldo: number;
  };
  missoes: {
    saldo: number;
  };
}

export const mockCategorias: CategoriaFinanceira[] = [
  // Categorias de Entrada
  { id: '1', nome: 'Dízimos', tipo: 'entrada', cor: '#10b981', icone: 'Heart' },
  { id: '2', nome: 'Ofertas', tipo: 'entrada', cor: '#3b82f6', icone: 'Gift' },
  { id: '3', nome: 'Doações', tipo: 'entrada', cor: '#8b5cf6', icone: 'HandHeart' },
  { id: '4', nome: 'Eventos', tipo: 'entrada', cor: '#f59e0b', icone: 'Calendar' },
  { id: '5', nome: 'Vendas', tipo: 'entrada', cor: '#06b6d4', icone: 'ShoppingBag' },

  // Categorias de Saída
  { id: '6', nome: 'Salários', tipo: 'saida', cor: '#ef4444', icone: 'Users' },
  { id: '7', nome: 'Manutenção', tipo: 'saida', cor: '#f97316', icone: 'Wrench' },
  { id: '8', nome: 'Utilidades', tipo: 'saida', cor: '#84cc16', icone: 'Zap' },
  { id: '9', nome: 'Material', tipo: 'saida', cor: '#ec4899', icone: 'Package' },
  { id: '10', nome: 'Eventos', tipo: 'saida', cor: '#6366f1', icone: 'Calendar' },
  { id: '11', nome: 'Missões', tipo: 'saida', cor: '#14b8a6', icone: 'Globe' },
  { id: '12', nome: 'Outros', tipo: 'saida', cor: '#64748b', icone: 'MoreHorizontal' },
]

export const mockTransacoes: TransacaoFinanceira[] = [
  // Entradas
  {
    id: '1',
    tipo: 'entrada',
    categoria: 'Dízimos',
    descricao: 'Dízimos - Dezembro 2024',
    valor: 15000.0,
    data: '2024-12-01',
    responsavel: 'João Silva',
    status: 'aprovado',
    observacoes: 'Coleta do primeiro domingo',
  },
  {
    id: '2',
    tipo: 'entrada',
    categoria: 'Ofertas',
    descricao: 'Ofertas - Culto Dominical',
    valor: 3500.0,
    data: '2024-12-08',
    responsavel: 'Maria Santos',
    status: 'aprovado',
  },
  {
    id: '3',
    tipo: 'entrada',
    categoria: 'Doações',
    descricao: 'Doação para reforma do templo',
    valor: 5000.0,
    data: '2024-12-10',
    responsavel: 'Pedro Costa',
    status: 'pendente',
    observacoes: 'Aguardando confirmação do doador',
  },
  {
    id: '4',
    tipo: 'entrada',
    categoria: 'Eventos',
    descricao: 'Bazar Beneficente',
    valor: 2800.0,
    data: '2024-12-15',
    responsavel: 'Ana Oliveira',
    status: 'aprovado',
  },

  // Saídas
  {
    id: '5',
    tipo: 'saida',
    categoria: 'Salários',
    descricao: 'Salário Pastor - Dezembro',
    valor: 4500.0,
    data: '2024-12-05',
    responsavel: 'Tesouraria',
    status: 'aprovado',
  },
  {
    id: '6',
    tipo: 'saida',
    categoria: 'Utilidades',
    descricao: 'Conta de Energia Elétrica',
    valor: 850.0,
    data: '2024-12-12',
    responsavel: 'Administração',
    status: 'aprovado',
    comprovante: 'comprovante_energia_dez24.pdf',
  },
  {
    id: '7',
    tipo: 'saida',
    categoria: 'Manutenção',
    descricao: 'Reparo do sistema de som',
    valor: 1200.0,
    data: '2024-12-18',
    responsavel: 'Ministério de Louvor',
    status: 'pendente',
    observacoes: 'Aguardando orçamento final',
  },
  {
    id: '8',
    tipo: 'saida',
    categoria: 'Material',
    descricao: 'Material de limpeza',
    valor: 320.0,
    data: '2024-12-20',
    responsavel: 'Zeladoria',
    status: 'aprovado',
  },
  {
    id: '9',
    tipo: 'saida',
    categoria: 'Missões',
    descricao: 'Apoio missionário - Família Rocha',
    valor: 800.0,
    data: '2024-12-22',
    responsavel: 'Ministério de Missões',
    status: 'aprovado',
  },
  {
    id: '10',
    tipo: 'entrada',
    categoria: 'Ofertas',
    descricao: 'Ofertas - Culto de Natal',
    valor: 4200.0,
    data: '2024-12-25',
    responsavel: 'Maria Santos',
    status: 'aprovado',
  },
  {
    id: '11',
    tipo: 'entrada',
    categoria: 'Missões',
    descricao: 'Oferta especial para missões',
    valor: 3500.0,
    data: '2024-12-15',
    responsavel: 'Ministério de Missões',
    status: 'aprovado',
    observacoes: 'Campanha de arrecadação para missões',
  },
  {
    id: '12',
    tipo: 'entrada',
    categoria: 'Missões',
    descricao: 'Doação para projeto missionário',
    valor: 2000.0,
    data: '2024-12-20',
    responsavel: 'Família Silva',
    status: 'aprovado',
  },
]

export const mockResumoFinanceiro: ResumoFinanceiro = {
  totalEntradas: mockTransacoes
    .filter((t) => t.tipo === 'entrada' && t.status === 'aprovado')
    .reduce((sum, t) => sum + t.valor, 0),
  totalSaidas: mockTransacoes
    .filter((t) => t.tipo === 'saida' && t.status === 'aprovado')
    .reduce((sum, t) => sum + t.valor, 0),
  saldo: 0, // Será calculado dinamicamente
  transacoesPendentes: mockTransacoes.filter((t) => t.status === 'pendente').length,
}

// Calcular saldo
mockResumoFinanceiro.saldo = mockResumoFinanceiro.totalEntradas - mockResumoFinanceiro.totalSaidas

// Dados para gráficos
export const mockDadosGrafico = {
  entradas: [
    { mes: 'Jul', valor: 18500 },
    { mes: 'Ago', valor: 22000 },
    { mes: 'Set', valor: 19800 },
    { mes: 'Out', valor: 21500 },
    { mes: 'Nov', valor: 20200 },
    { mes: 'Dez', valor: 25500 },
  ],
  saidas: [
    { mes: 'Jul', valor: 15200 },
    { mes: 'Ago', valor: 16800 },
    { mes: 'Set', valor: 14900 },
    { mes: 'Out', valor: 17200 },
    { mes: 'Nov', valor: 15800 },
    { mes: 'Dez', valor: 16670 },
  ],
}

// Solicitações de Verba e Prestações de Contas
export type SolicitacaoStatus = 'pendente' | 'aprovado' | 'rejeitado' | 'em_analise'

export interface SolicitacaoVerba {
  id: string
  ministerioId: string
  titulo: string
  motivo: string
  valor: number
  solicitante: string
  data: string
  status: SolicitacaoStatus
  prioridade?: 'baixa' | 'media' | 'alta' | 'urgente'
  observacoes?: string
}

export interface PrestacaoConta {
  id: string
  ministerioId: string
  titulo: string
  valor: number
  autor: string
  data: string
  notaFiscalUrl?: string // placeholder para foto da nota
  observacoes?: string
}

export interface EntradaMinisterio {
  id: string
  ministerioId: string
  tipo: 'oferta' | 'cantina' | 'doacao'
  valor: number
  responsavel: string
  data: string
  observacoes?: string
}

export const mockSolicitacoes: SolicitacaoVerba[] = [
  {
    id: 's1',
    ministerioId: '1',
    titulo: 'Solicitação equipamento de som',
    motivo: 'Atualização do sistema de som do salão principal',
    valor: 5000,
    solicitante: 'Líder Louvor',
    data: '2024-12-02',
    status: 'pendente',
  },
  {
    id: 's2',
    ministerioId: '2',
    titulo: 'Materiais para encontro de jovens',
    motivo: 'Compra de materiais e lanches para evento',
    valor: 800,
    solicitante: 'Líder Jovens',
    data: '2024-12-07',
    status: 'aprovado',
  },
  {
    id: 's3',
    ministerioId: '4',
    titulo: 'Projeto social - doações',
    motivo: 'Compra de cestas básicas para família atendida',
    valor: 1200,
    solicitante: 'Líder Ação Social',
    data: '2024-12-10',
    status: 'pendente',
  },
]

export const mockPrestacoes: PrestacaoConta[] = [
  {
    id: 'p1',
    ministerioId: '2',
    titulo: 'Prestação - Encontro Jovens',
    valor: 750,
    autor: 'Líder Jovens',
    data: '2024-12-12',
    notaFiscalUrl: 'nota_encontro_jovens.jpg',
    observacoes: 'Compra de materiais e lanches',
  },
]

export const mockEntradasMinisterios: EntradaMinisterio[] = [
  {
    id: 'e1',
    ministerioId: '1',
    tipo: 'oferta',
    valor: 1500,
    responsavel: 'Líder Louvor',
    data: '2024-12-01',
    observacoes: 'Oferta especial para equipamentos',
  },
  {
    id: 'e2',
    ministerioId: '1',
    tipo: 'doacao',
    valor: 2000,
    responsavel: 'Membro da Igreja',
    data: '2024-12-05',
    observacoes: 'Doação para reforma do sistema de som',
  },
  {
    id: 'e3',
    ministerioId: '2',
    tipo: 'cantina',
    valor: 800,
    responsavel: 'Líder Jovens',
    data: '2024-12-08',
    observacoes: 'Venda de lanches no encontro',
  },
  {
    id: 'e4',
    ministerioId: '3',
    tipo: 'oferta',
    valor: 600,
    responsavel: 'Líder Crianças',
    data: '2024-12-10',
    observacoes: 'Oferta para materiais didáticos',
  },
  {
    id: 'e5',
    ministerioId: '4',
    tipo: 'doacao',
    valor: 1200,
    responsavel: 'Família Silva',
    data: '2024-12-15',
    observacoes: 'Doação para projeto social',
  },
]

// Saldo reservado pela administração (fundo disponível para distribuição)
export const mockAdministracaoFundo = {
  disponivel: 20000,
}

// Saldos por ministério (disponível para o próprio ministério)
export interface SaldoMinisterio {
  ministerioId: string
  saldoDisponivel: number
  reservado?: number
}

export const mockSaldoMinisterios: SaldoMinisterio[] = [
  { ministerioId: '1', saldoDisponivel: 5000, reservado: 0 },
  { ministerioId: '2', saldoDisponivel: 1200, reservado: 100 },
  { ministerioId: '3', saldoDisponivel: 800, reservado: 0 },
  { ministerioId: '4', saldoDisponivel: 1500, reservado: 300 },
  { ministerioId: '5', saldoDisponivel: 600, reservado: 0 },
  { ministerioId: '6', saldoDisponivel: 400, reservado: 0 },
]

// Resumo financeiro por ministério (exposição para relatórios)
export interface ResumoMinisterio {
  ministerioId: string
  nome: string
  entradas: number
  saidas: number
  saldo: number
}

export const mockResumoPorMinisterio: ResumoMinisterio[] = [
  { ministerioId: '1', nome: 'Ministério de Louvor', entradas: 18500, saidas: 13500, saldo: 5000 },
  { ministerioId: '2', nome: 'Ministério de Jovens', entradas: 5200, saidas: 4000, saldo: 1200 },
  { ministerioId: '3', nome: 'Ministério de Crianças', entradas: 3000, saidas: 2200, saldo: 800 },
  {
    ministerioId: '4',
    nome: 'Ministério de Ação Social',
    entradas: 4200,
    saidas: 2700,
    saldo: 1500,
  },
  {
    ministerioId: '5',
    nome: 'Ministério de Intercessão',
    entradas: 1600,
    saidas: 1000,
    saldo: 600,
  },
  { ministerioId: '6', nome: 'Ministério de Recepção', entradas: 1100, saidas: 700, saldo: 400 },
]

// Saldo separado entre Igreja e Missões
export const mockSaldoSeparado: SaldoSeparado = {
  igreja: {
    saldo: 25000.00,
  },
  missoes: {
    saldo: 18000.00,
  },
}

// Dados de gráfico específicos para missões
export const mockDadosGraficoMissoes = {
  entradas: [
    { mes: 'Jul', valor: 2500 },
    { mes: 'Ago', valor: 3200 },
    { mes: 'Set', valor: 2800 },
    { mes: 'Out', valor: 3500 },
    { mes: 'Nov', valor: 3000 },
    { mes: 'Dez', valor: 4000 },
  ],
  saidas: [
    { mes: 'Jul', valor: 1800 },
    { mes: 'Ago', valor: 2100 },
    { mes: 'Set', valor: 1900 },
    { mes: 'Out', valor: 2400 },
    { mes: 'Nov', valor: 2200 },
    { mes: 'Dez', valor: 2800 },
  ],
}

export const mockDistribuicaoMissoes = [
  { tipo: 'Internacional', valor: 15000, cor: '#3b82f6', percentual: 45 },
  { tipo: 'Nacional', valor: 8000, cor: '#10b981', percentual: 24 },
  { tipo: 'Local', valor: 6000, cor: '#f59e0b', percentual: 18 },
  { tipo: 'Social', valor: 4500, cor: '#8b5cf6', percentual: 13 },
]
